module.exports = __webpack_public_path__ + "img/scene5-10.6ed23d03.jpg";